import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { createValue, Fieldset } from '@bigfishtv/react-forms'
import { validationErrors } from 'react-forms-cakephp'

import invalidateExternalErrorList from '../../base/utils/invalidateExternalErrorList'

import FormButton from '../../base/components/FormButton'
import Field from '../../base/components/Field'

const FormFields = ({ preferences }) => (
  <div>
    <div className="fields">
      <Field className="flex-auto" select="first_name" label="First Name" required />
      <Field className="flex-auto" select="last_name" label="Last Name" required />
    </div>
    <Field className="flex-auto" select="email" type="email" label="Email" required />
    <div className="fields">
      <Field className="flex-auto" select="city" label="City" />
      <Field className="flex-auto" select="postcode" type="tel" label="Postcode" required />
    </div>
    <div className="margin-vertical-s">
      <Field
        select="preferences"
        label="Preferences"
        type="checkboxes"
        text="Subscription Preferences"
        options={preferences}
        required
      />
    </div>
  </div>
)

const SuccessMessage = () => (
  <div className="margin-top-m min-height-50vh">
    <h2 className="title title-s">Thank you for subscribing.</h2>
  </div>
)

class SubscribeForm extends Component {
  constructor(props) {
    super()
    this.state = {
      formValue: createValue({
        value: { preferences: props.preferences.map(({ value }) => value) },
        onChange: this.onChange,
      }),
      submitStatus: 'ready',
    }
  }
  onChange = formValue => {
    formValue = invalidateExternalErrorList(formValue, this.state.formValue)
    this.setState({ formValue, submitStatus: this.state.submitStatus != 'busy' ? 'ready' : 'busy' })
  }
  handleSubmit = event => {
    event.preventDefault()

    if (this.state.submitStatus == 'busy') return

    this.setState(
      {
        submitStatus: 'busy',
      },
      () => {
        window.jQuery.ajax({
          type: 'POST',
          url: '/api/subscribers/submit.json',
          data: JSON.stringify(this.state.formValue.value),
          contentType: 'application/json',
          dataType: 'json',
          success: () => {
            this.setState({ submitStatus: 'success' })
          },
          error: response => {
            if (response.responseJSON && response.responseJSON.errors) {
              this.onChange(
                createValue({
                  value: this.state.formValue.value,
                  onChange: this.onChange,
                  params: { forceShowErrors: true },
                  externalErrorList: validationErrors(response.responseJSON.errors),
                })
              )
            }
            this.setState({ submitStatus: 'failed' })
          },
        })
      }
    )
  }
  render() {
    const { submitStatus } = this.state
    if (submitStatus === 'success') {
      return (
        <div
          ref={el => {
            // hide the form intro
            window.jQuery(`[data-hide-after-submit="${this.props.formId}"]`).hide()

            // scroll the view
            window
              .jQuery(el)
              .parents('section')
              .get(0)
              .scrollIntoView(true)
          }}>
          <SuccessMessage />
        </div>
      )
    }

    return (
      <Fieldset stylesheet={{ Root: 'form' }} formValue={this.state.formValue} onSubmit={this.handleSubmit}>
        <FormFields preferences={this.props.preferences} />
        <FormButton
          onSubmit={this.handleSubmit}
          submitStatus={submitStatus}
          submitClassName="button-dark button-border"
        />
      </Fieldset>
    )
  }
}

window.SubscribeForm = {
  init: (id, props) => {
    if (!props.preferences) {
      props.preferences = [
        { value: '243', text: 'At The Barre – Queensland Ballet eNews' }, // Tag grabbed from insomnia
        // { value: 'd1489d96-476d-e911-a31f-e61f134a8c87', text: 'Community, Learning and Industry news' },
        // { value: '0745c9f9-b4d0-e711-bcb0-e61f134a8c87', text: 'News for School Teachers' },
        // { value: '6d82cbff-b4d0-e711-bcb0-e61f134a8c87', text: 'News for Dance Studios' },
      ]
    }
    ReactDOM.render(<SubscribeForm {...props} formId={id} />, document.getElementById(id))
  },
}
